import { i18n } from '@/i18n/instance';
import { useLocaleStore } from '@/stores/useLocaleStore';

const useTranslation = () => {
  const locale = useLocaleStore((state) => state.locale);

  return { t: i18n.t, locale };
};

export { useTranslation };
